import isEmail from "sane-email-validation";

const validate = (values, language) => {
  // const { language } = props;

  const errors = {};
  if (!values.email) {
    errors.email = language.MemberForm && language.MemberForm.Email_Required;
  } else if (
    values.email &&
    values.email.length > 0 &&
    !isEmail(values.email)
  ) {
    errors.email = language.MemberForm && language.MemberForm.Email_Invalid;
  }

  return errors;
};

export default validate;
